import React from 'react';
import css from './spinner.module.css';

export default function Spinner({
  visible = true,
  size = 'sm',
  className,
}: {
  visible: boolean;
  size?: 'sm' | 'lg';
  className?: string;
}) {
  const classNames = ''
    .concat(css['spinner'], ' ')
    .concat(className ? className : '');

  const sizeEm = size === 'sm' ? '1em' : '2em';

  const strokeWidth = size === 'sm' ? '20' : '10';

  if (!visible) {
    return <></>;
  } else {
    return (
      <svg
        className={classNames}
        width={sizeEm}
        height={sizeEm}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className={css['path']}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          cx="50"
          cy="50"
          r="40"
        ></circle>
      </svg>
    );
  }
}
